module.exports = __webpack_public_path__ + "static/media/fam_knol_vertical.46454311.jpg";